import { render, staticRenderFns } from "./PartnersTable.vue?vue&type=template&id=02259053"
import script from "./PartnersTable.vue?vue&type=script&lang=js"
export * from "./PartnersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports